import { useEffect } from 'react'
import { useCurrentProject } from 'src/providers/current-project.provider'
import type { EHumanReviewTab, THumanReviewListItem } from './human-review-requests.type'
import {
  getLastPatientMedEventId,
  pickPatientMedEventId,
  setLastPatientMedEventId,
} from './last-patient-med-event.util'

type TProps = {
  subject: EHumanReviewTab
  // undefined while the list of the tab is not ready (loading, or still the one of the previous tab)
  items: THumanReviewListItem[] | undefined
  selectedId: number | null
  onSelect: (patientMedEventId: number) => void
}

// A patient is always selected once the list is ready, and remembered as the last one seen on the tab
export const useAutoSelectedPatient = ({ subject, items, selectedId, onSelect }: TProps) => {
  const { project } = useCurrentProject()

  useEffect(() => {
    if (!items?.length) return

    const patientMedEventId = pickPatientMedEventId({
      listedIds: items.map((listItem) => listItem.patientMedEventId),
      selectedId,
      lastSeenId: getLastPatientMedEventId(project.id, subject),
    })
    setLastPatientMedEventId(project.id, subject, patientMedEventId)
    if (patientMedEventId !== selectedId) onSelect(patientMedEventId)
  }, [items, project.id, subject, selectedId, onSelect])
}
